// extracted by mini-css-extract-plugin
export default {"container":"SPModal_container__U2rIP","content":"SPModal_content__If3qX","backdrop":"SPModal_backdrop__R+s49"};